import React, { Component } from 'react';
import { createClient } from 'contentful';
import './App.css';
import './Dashboard.css';

class Dashboard extends Component {
  constructor(props) {
    super(props);

    // Set initial state
    this.state = {
      averages: [],
      biasTests: []
    }
  }

  componentDidMount() {
    fetch('https://us-central1-hrx-biastest.cloudfunctions.net/averageScore', {
      method: 'GET',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'Access-Control-Allow-Origin': '*'
      }
    }).then((response) => {
      return response.json()
    }).then((responseJson) => {
      console.log(responseJson)
      this.setState({
        averages: responseJson,
      })
    }).catch((e) => console.log(e));

    // Retrieve all entries of this test
    var client = createClient({
      space: '4xbeshmjlgqs',
      accessToken: '3bfead8c496ebd173c5b896acee22b2a9011df359db822a91d34dffd90abea07'
    });

    client.getEntries(
      {
        content_type: 'biasTest',
        include: 5
      })
      .then((response) => {
        this.setState({
          biasTests: response.items
        })
      })
  }

  render() {
    function Averages(props) {
      const data = props.averages
      const tests = props.tests
      const avgs = []
      for (var key in data) {
        if (data.hasOwnProperty(key)) {
          let testName = key
          for (let i = 0; i < tests.length; i++) {
            let test = tests[i];
            if (test.sys.id === key) {
              testName = test.fields.testTitle
            }
          }
          const score = data[key].avg / 1000
          let strength = 'unknown'
          // Calculate strength
          if (score >= -0.15 && score < 0.15) {
            strength = "none";
          } else if ((score >= 0.15 && score < 0.35) || (score >= -0.35 && score < -0.15)) {
            strength = "slight";
          } else if ((score >= 0.35 && score < 0.65) || (score >= -0.65 && score < -0.35)) {
            strength = "moderate";
          } else if ((score >= 0.65 && score < 2) || (score >= -2 && score < -0.65)) {
            strength = "strong";
          } else {
            strength = "very strong";
          }
          avgs.push(
            <div key={key}>
              <h2>{testName}</h2>
              <p>Score: {score}</p>
              <p>Bias: {strength}</p>
              <hr />
            </div>
          )
        }
      }
      return avgs;
    }

    return (
      <div className="DashboardPage">
        <h1>Bias Test Results</h1>
        <div>
          <Averages averages={this.state.averages} tests={this.state.biasTests} />
        </div>
      </div>
    );
  }
}

export default Dashboard;
